const Account = require('eth-lib/lib/account');
const utils = require('web3-utils');
const elliptic = require('elliptic');
const secp256k1 = new elliptic.ec('secp256k1');

export const viteContractAddr = process.env.contractAddress;

export const viteContractAbi = [ {
    'constant': true,
    'inputs': [],
    'name': 'name',
    'outputs': [{ 'name': '', 'type': 'string' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
}, {
    'constant': false,
    'inputs': [ { 'name': '_spender', 'type': 'address' }, { 'name': '_value', 'type': 'uint256' } ],
    'name': 'approve',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
}, {
    'constant': true,
    'inputs': [],
    'name': 'totalSupply',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
}, {
    'constant': false,
    'inputs': [ { 'name': '_from', 'type': 'address' }, { 'name': '_to', 'type': 'address' }, { 'name': '_value', 'type': 'uint256' } ],
    'name': 'transferFrom',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
}, {
    'constant': true,
    'inputs': [],
    'name': 'decimals',
    'outputs': [{ 'name': '', 'type': 'uint8' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
}, {
    'constant': false,
    'inputs': [ { 'name': '_spender', 'type': 'address' }, { 'name': '_subtractedValue', 'type': 'uint256' } ],
    'name': 'decreaseApproval',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
}, {
    'constant': true,
    'inputs': [{ 'name': '_owner', 'type': 'address' }],
    'name': 'balanceOf',
    'outputs': [{ 'name': 'balance', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
}, {
    'constant': true,
    'inputs': [],
    'name': 'symbol',
    'outputs': [{ 'name': '', 'type': 'string' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
}, {
    'constant': false,
    'inputs': [ { 'name': '_to', 'type': 'address' }, { 'name': '_value', 'type': 'uint256' } ],
    'name': 'transfer',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
}, {
    'constant': false,
    'inputs': [ { 'name': '_spender', 'type': 'address' }, { 'name': '_addedValue', 'type': 'uint256' } ],
    'name': 'increaseApproval',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function'
}, {
    'constant': true,
    'inputs': [ { 'name': '_owner', 'type': 'address' }, { 'name': '_spender', 'type': 'address' } ],
    'name': 'allowance',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function'
}, { 'inputs': [], 'payable': false, 'stateMutability': 'nonpayable', 'type': 'constructor' }, { 'payable': true, 'stateMutability': 'payable', 'type': 'fallback' }, {
    'anonymous': false,
    'inputs': [ { 'indexed': true, 'name': 'owner', 'type': 'address' }, { 'indexed': true, 'name': 'spender', 'type': 'address' }, { 'indexed': false, 'name': 'value', 'type': 'uint256' } ],
    'name': 'Approval',
    'type': 'event'
}, {
    'anonymous': false,
    'inputs': [ { 'indexed': true, 'name': 'from', 'type': 'address' }, { 'indexed': true, 'name': 'to', 'type': 'address' }, { 'indexed': false, 'name': 'value', 'type': 'uint256' } ],
    'name': 'Transfer',
    'type': 'event'
} ];

export const blackHole = '0x1111111111111111111111111111111111111111';

export const signBinding = function ({ hash, viteAddr, value, privateKey, ethAddr }) {
    const ecKey = secp256k1.keyFromPrivate(privateKey);
    const pubKey = `0x${ ecKey.getPublic(false, 'hex') }`;
    const privKey = utils.bytesToHex(privateKey);

    const BindReq = {
        'pub_key': pubKey,
        'eth_tx_hash': hash,
        'eth_addr': ethAddr,
        'vite_addr': viteAddr,
        value
    };

    const text = JSON.stringify(BindReq);
    const bindingHash = utils.soliditySha3(text);
    BindReq.signature = Account.sign(bindingHash, privKey);

    return BindReq;
};
